import { createFileRoute } from '@tanstack/react-router';

import { SecurityPage } from '../../auth/security-page';

/**
 * `/account/security` (M2.8).
 *
 * No `RequirePermission`: these are the operator's own credentials, and every platform
 * role may manage them. The route sits behind `RequireAuth` and `RequireMfa` through the
 * root layout like every other console screen.
 */
export const Route = createFileRoute('/account/security')({
  component: SecurityPage,
});
